import language from '../../config/language.json';

const DEFAULT_LANG_CODE = 'hu_HU';

class LanguageHandler {
  constructor(languageCode) {
    if (!languageCode) {
      languageCode = DEFAULT_LANG_CODE;
    }

    const assortedLangData = {};

    Object.keys(language).forEach((value, index) => {
      if (!language[value][languageCode]) {
        languageCode = DEFAULT_LANG_CODE;
      }

      if (language[value][languageCode]) {
        assortedLangData[value] = language[value][languageCode];
      } else {
        assortedLangData[value] = language[value][DEFAULT_LANG_CODE];
      }
    });

    return assortedLangData;
  }
}

export default LanguageHandler;



// WEBPACK FOOTER //
// ./src/components/language/LanguageHandler.js